export const iconFontSize = '1.5rem'

export const typography = {
  fontFamily: `"Roboto","Helvetica","Arial",sans-serif;`,
  h1: {
    fontWeight: 700,
    fontSize: 56,
    letterSpacing: '-1.5px',
  },
  h2: {
    fontWeight: 700,
    fontSize: 48,
    letterSpacing: '-0.5px',
  },
  h3: {
    fontWeight: 700,
    fontSize: 36,
    letterSpacing: '0px',
  },
  h4: {
    fontWeight: 700,
    fontSize: 32,
    letterSpacing: '0.25px',
  },
  h5: {
    fontWeight: 700,
    fontSize: 24,
    letterSpacing: '0px',
  },
  h6: {
    fontWeight: 700,
    fontSize: 18,
    letterSpacing: '0.15px',
  },
  subtitle1: {
    fontWeight: 700,
    fontSize: 15,
    letterSpacing: '0.18px',
  },
  subtitle2: {
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: '0.15px',
  },
  subtitle3: {
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: '0.1px',
  },
  body0: {
    fontWeigh: 500,
    fontSize: 17,
    letterSpacing: '0.22px',
  },
  body1: {
    fontWeigh: 500,
    fontSize: 15,
    letterSpacing: '0.18px',
  },
  body2: {
    fontWeight: 500,
    fontSize: 13,
    letterSpacing: '0.15px',
  },
  body3: {
    fontWeight: 500,
    fontSize: 11,
    letterSpacing: '0.11px',
  },
  caption: {
    fontWeight: 500,
    fontSize: 12,
    letterSpacing: '0.4px',
  },
  overline: {
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '1px',
  },
  default: 'body0',
} as const
